import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';

import SimpleTable from '../../../components/tables/simpleTable';

import SearchFilter from '../../../components/filters/search';
import DatePicker from '../../../components/filters/datePicker';
import Loader from '../../../components/loader/loader';
import { numberFormatter } from '../../../components/formatters/numberFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card, Divider } from 'antd';

import { FcViewDetails } from "react-icons/fc";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { DataContext } from '../../../init/getData';
import ViewModal from '../../../components/modals/viewModal';
import AccountStatementReport from './accountStatementReport';




function AccountStatement(props) {

  let { type, isDebit } = props;

  const { api, userData, settingData, auxAccountData, refData, companyId, selectedYear,
    yearId, mainCurrency, secondaryCurrency } = useContext(DataContext);

  const reportRef = useRef(null);

  const statementreportRef = useRef(null);

  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const createdBy = parseInt(userData.id);
  const [showReportModal, setShowReportModal] = useState(false);
  const [currency, setCurrency] = useState('main');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['auxAccount']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);



  const table = 'accountStatement';
  const title = 'Statement';


  const fromDate = selectedYear?.year + '-01-01';
  const toDate = selectedYear?.year + '-12-31';

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', fromDate: fromDate, toDate: toDate, companyId, yearId });

  //change Type
  useEffect(() => {
    setFilter(prevFilter => ({ ...prevFilter, accountId: selectedAccount?.value, currencyId: selectedCurrency?.value }));
  }, [selectedAccount, selectedCurrency]);


  const [showViewModal, setShowViewModal] = useState(false);

  // Account Options
  const accountOptions = auxAccountData?.map(item => ({
    value: item.id,
    label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english,
  }));

  // Load and filter account options
  const loadAccountOptions = (inputValue, callback) => {
    const filteredOptions = inputValue ? accountOptions.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
    callback(filteredOptions);
  };



  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }

  const reportModal = (e) => {
    setShowReportModal(!showReportModal);
  }


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        "Jv-ID": item.journalVoucherId,
        Date: item.journalVoucher?.date,
        Type: item.journalVoucher?.type,
        Currency: item.currency?.code,
        Debit: numberFormatter(item.debit),
        Credit: numberFormatter(item.credit),
        [`Debit ${mainCurrency?.code}`]: numberFormatter(item.totalDebit),
        [`Credit ${mainCurrency?.code}`]: numberFormatter(item.totalCredit),
        [`Debit ${secondaryCurrency?.code}`]: numberFormatter(item.secondaryTotalDebit),
        [`Credit ${secondaryCurrency?.code}`]: numberFormatter(item.secondaryTotalCredit),
        [`Balance ${mainCurrency?.code}`]: numberFormatter(item.cumulativeBalance),
        [`Balance ${secondaryCurrency?.code}`]: numberFormatter(item.secondaryCumulativeBalance),
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };


  let newColumnDefs = useMemo(() => [
    { title: 'Jv-ID', dataIndex: 'journalVoucherId', width: '5%'},
    { title: 'Date', dataIndex: 'journalVoucher', render: (journalVoucher) => (journalVoucher?.date), width: '8%' },
    { title: 'Details', dataIndex: 'details', width: '10%' },
    { title: 'Type', dataIndex: 'journalVoucher', render: (journalVoucher) => (journalVoucher?.type), width: '6%' },
    { title: 'Currency', dataIndex: 'currency', render: (currency) => (currency?.code), width: '5%' },
    { title: 'Debit', dataIndex: 'debit', render: numberFormatter },
    { title: 'Credit', dataIndex: 'credit', render: numberFormatter },
    { title: 'Debit ' + mainCurrency?.code, dataIndex: 'totalDebit', render: numberFormatter },
    { title: 'Credit ' + mainCurrency?.code, dataIndex: 'totalCredit', render: numberFormatter },
    { title: 'Debit ' + secondaryCurrency?.code, dataIndex: 'secondaryTotalDebit', render: numberFormatter },
    { title: 'Credit ' + secondaryCurrency?.code, dataIndex: 'secondaryTotalCredit', render: numberFormatter },
    { title: 'Balance' + mainCurrency?.code, dataIndex: 'cumulativeBalance', render: numberFormatter },
    { title: 'Balance' + secondaryCurrency?.code, dataIndex: 'secondaryCumulativeBalance', render: numberFormatter },
    {
      title: 'View',
      width: '5%',
      render: (_, record) => (
        <FcViewDetails size={20} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
      ),
    }
  ]);

  const groupByJournalVoucherId = (items) => {
    const grouped = {};

    items.forEach(item => {
      const id = item.journalVoucherId;
      if (!grouped[id]) {
        grouped[id] = {
          ...item,
          totalDebit: item.totalDebit || 0,
          totalCredit: item.totalCredit || 0,
          secondaryTotalDebit: item.secondaryTotalDebit || 0,
          secondaryTotalCredit: item.secondaryTotalCredit || 0,
          cumulativeBalance: item.cumulativeBalance || 0,
          secondaryCumulativeBalance: item.secondaryCumulativeBalance || 0,
        };
      } else {
        // If the ID already exists, merge the amounts
        grouped[id].totalDebit += item.totalDebit || 0;
        grouped[id].totalCredit += item.totalCredit || 0;
        grouped[id].secondaryTotalDebit += item.secondaryTotalDebit || 0;
        grouped[id].secondaryTotalCredit += item.secondaryTotalCredit || 0;
        grouped[id].cumulativeBalance = item.cumulativeBalance; // or update as needed
        grouped[id].secondaryCumulativeBalance = item.secondaryCumulativeBalance;
      }
    });

    return Object.values(grouped);
  };




  const tableFooter = (
    <div style={{ marginRight: "550px" }}>
      <Tag color="green" style={{ fontSize: '18px' }}>
      </Tag>
    </div>
  )

  const report = (
    <Card
      title={<div style={{ textAlign: 'center', fontSize: 40 }}>Account Statement</div>}
      bordered={true}
      style={{ width: '100%', alignSelf: 'center' }}
      headStyle={{ textAlign: 'center' }}
      ref={reportRef}
    >
      <div style={{ width: '80%', margin: '0 auto' }}>
        {/* Date */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h5 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Date:</h5>
          <h5>{filter.fromDate} to {filter.toDate}</h5>
        </div>

        {/* Account */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h5 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Account:</h5>
          <h5>{selectedAccount?.label || 'All Accounts'}</h5>
        </div>

        {/* Currency */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h5 style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Currency:</h5>
          <h5>{selectedCurrency?.label || 'All Currencies'}</h5>
        </div>

        <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />

        {/* Summary Section */}
        <h5 style={{ textDecoration: 'underline', fontWeight: 'bold', marginTop: '30px' }}>Summary</h5>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h5>Total Debit ({mainCurrency?.code}):</h5>
            <h5>{numberFormatter(data?.summary?.totalDebit, 2)}</h5>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h5>Total Credit ({mainCurrency?.code}):</h5>
            <h5>{numberFormatter(data?.summary?.totalCredit, 2)}</h5>
          </div>

          <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h5 style={{ textDecoration: 'underline', fontWeight: 'bold', fontSize: '25px' }}>Balance ({mainCurrency?.code}):</h5>
            <h5 style={{
              color: (data?.summary?.totalDebit - data?.summary?.totalCredit) > 0 ? 'green' : 'red',
              fontSize: '25px'
            }}>
              {numberFormatter(data?.summary?.totalDebit - data?.summary?.totalCredit, 2)}
            </h5>
          </div>
        </div>
      </div>
    </Card>
  );

  const statementReport = (
    <Card ref={statementreportRef}>
      {/* Title */}
      <div style={{ textAlign: 'center', fontSize: 20, fontWeight: 'bold', color: '#000', marginBottom: 16 }}>
        STATEMENT OF ACCOUNT
      </div>

      {/* Header Information */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24, fontSize: 14 }}>
        <div><strong>Period:</strong> {filter.fromDate} to {filter.toDate}</div>
        <div><strong>Account:</strong> {selectedAccount?.label || 'All Accounts'}</div>
        <div><strong>Currency:</strong> {selectedCurrency?.label || 'All Currencies'}</div>
      </div>

      {/* Table */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 16, border: '1px solid #000' }}>
        <thead>
          <tr>
            {['ID', 'Date', 'Payment Type', 'Type', 'Debit', 'Credit', 'Balance'].map((header, index) => (
              <th
                key={index}
                style={{
                  textAlign: index > 3 ? 'right' : 'left',
                  padding: '10px',
                  borderBottom: '2px solid #000',
                  borderRight: index !== 6 ? '1px solid #000' : 'none',
                  fontWeight: 'bold',
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(() => {
            // Group items by journalVoucherId
            const groupedItems = {};
            data?.data?.forEach(item => {
              if (!groupedItems[item.journalVoucherId]) {
                groupedItems[item.journalVoucherId] = [];
              }
              groupedItems[item.journalVoucherId].push(item);
            });

            // Calculate running balance for each group
            let cumBalance = 0;
            let secondaryCumBalance = 0;
            const useMainCurrency = !selectedCurrency || selectedCurrency?.value === mainCurrency?.value;

            return Object.entries(groupedItems).map(([id, items]) => {
              // Calculate totals for the group
              const groupTotalDebit = items.reduce((sum, item) => sum + (item.totalDebit || 0), 0);
              const groupTotalCredit = items.reduce((sum, item) => sum + (item.totalCredit || 0), 0);
              const groupSecondaryTotalDebit = items.reduce((sum, item) => sum + (item.secondaryTotalDebit || 0), 0);
              const groupSecondaryTotalCredit = items.reduce((sum, item) => sum + (item.secondaryTotalCredit || 0), 0);

              // Update running balance
              cumBalance += groupTotalDebit - groupTotalCredit;
              secondaryCumBalance += groupSecondaryTotalDebit - groupSecondaryTotalCredit;

              // Get all unique payment types for this group
              const paymentTypes = [...new Set(items.map(item => item.journalVoucher?.paymentType))].join(', ');

              return items.map((item, index) => {
                const formattedDate = new Date(item.journalVoucher?.date).toLocaleDateString();
                const isFirstRow = index === 0;
                const isLastRow = index === items.length - 1;

                return (
                  <tr key={`${id}-${index}`} style={{ borderBottom: isLastRow ? '1px solid #000' : 'none' }}>
                    {/* ID column - only show in first row of group */}
                    <td style={{
                      padding: '10px',
                      borderRight: '1px solid #000',
                      borderBottom: isLastRow ? '1px solid #000' : 'none',
                      verticalAlign: 'top'
                    }}>
                      {isFirstRow ? id : ''}
                    </td>

                    {/* Date column - only show in first row of group */}
                    <td style={{
                      padding: '10px',
                      borderRight: '1px solid #000',
                      borderBottom: isLastRow ? '1px solid #000' : 'none',
                      verticalAlign: 'top'
                    }}>
                      {isFirstRow ? formattedDate : ''}
                    </td>

                    {/* Payment Type column - show all payment types for the group */}
                    <td style={{
                      padding: '10px',
                      borderRight: '1px solid #000',
                      borderBottom: isLastRow ? '1px solid #000' : 'none',
                      verticalAlign: 'top'
                    }}>
                      {isFirstRow ? item.journalVoucher?.paymentType : ''}
                    </td>

                    {/* Type column */}
                    <td style={{
                      padding: '10px',
                      borderRight: '1px solid #000',
                      borderBottom: isLastRow ? '1px solid #000' : 'none',
                      verticalAlign: 'top'
                    }}>
                      {item.journalVoucher?.type}
                    </td>

                    {/* Debit column */}
                    <td style={{
                      textAlign: 'right',
                      padding: '10px',
                      borderRight: '1px solid #000',
                      borderBottom: isLastRow ? '1px solid #000' : 'none',
                      verticalAlign: 'top'
                    }}>
                      <>
                        {currency == 'main' &&
                          numberFormatter(item.totalDebit)
                        }
                        {currency == 'secondary' &&
                          numberFormatter(item.secondaryTotalDebit)
                        }
                      </>

                    </td>

                    {/* Credit column */}
                    <td style={{
                      textAlign: 'right',
                      padding: '10px',
                      borderRight: '1px solid #000',
                      borderBottom: isLastRow ? '1px solid #000' : 'none',
                      verticalAlign: 'top'
                    }}>
                      <>
                        {currency == 'main' &&
                          numberFormatter(item.totalCredit)
                        }
                        {currency == 'secondary' &&
                          numberFormatter(item.secondaryTotalCredit)
                        }
                      </>

                    </td>

                    {/* Balance column - only show in last row of group */}
                    <td style={{
                      textAlign: 'right',
                      padding: '10px',
                      borderBottom: isLastRow ? '1px solid #000' : 'none',
                      verticalAlign: 'top'
                    }}>
                      {isLastRow && (
                        <>
                          {currency == 'main' &&
                            numberFormatter(cumBalance)
                          }
                          {currency == 'secondary' &&
                            numberFormatter(secondaryCumBalance)
                          }
                        </>
                      )}

                    </td>
                  </tr>
                );
              });
            });
          })()}

          {/* Summary Row */}
          <tr style={{ fontWeight: 'bold', borderTop: '2px solid #000' }}>
            <td colSpan="4" style={{ padding: '10px', borderRight: '1px solid #000' }}>TOTAL</td>
            <td style={{ textAlign: 'right', padding: '10px', borderRight: '1px solid #000' }}>
              <>
                {numberFormatter(data?.summary?.totalDebit)} {mainCurrency?.code}
                {secondaryCurrency?.code && (
                  <>
                    <br />
                    {numberFormatter(data?.summary?.secondaryTotalDebit)} {secondaryCurrency?.code}
                  </>
                )}
              </>

            </td>
            <td style={{ textAlign: 'right', padding: '10px', borderRight: '1px solid #000' }}>
              <>
                {numberFormatter(data?.summary?.totalCredit)} {mainCurrency?.code}
                {secondaryCurrency?.code && (
                  <>
                    <br />
                    {numberFormatter(data?.summary?.secondaryTotalCredit)} {secondaryCurrency?.code}
                  </>
                )}
              </>

            </td>
            <td style={{ textAlign: 'right', padding: '10px' }}>
              <>
                {numberFormatter((data?.summary?.totalDebit || 0) - (data?.summary?.totalCredit || 0))} {mainCurrency?.code}
                {secondaryCurrency?.code && (
                  <>
                    <br />
                    {numberFormatter((data?.summary?.secondaryTotalDebit || 0) - (data?.summary?.secondaryTotalCredit || 0))} {secondaryCurrency?.code}
                  </>
                )}
              </>
            </td>


          </tr>
        </tbody>
      </table>

      {/* Footer */}
      <div style={{ marginTop: 24, textAlign: 'right', fontSize: 12, color: '#000', padding: '10px 0', borderTop: '1px solid #000' }}>
        Generated on: {new Date().toLocaleDateString()} by {userData.name}
      </div>
    </Card>
  );




  return (
    <div>

      {isLoading &&
        <Loader />
      }

      {!isLoading &&
        <div>


          <Row className="mb-3 g-1">
            <Col md={3}>
              <AsyncSelect
                styles={selectStyles}
                cacheOptions
                isClearable={true}
                loadOptions={loadAccountOptions}
                defaultOptions={[]}
                onChange={setSelectedAccount}
                value={selectedAccount}
                noOptionsMessage={() => 'type to view'}
                placeholder="Select Account"
              />
            </Col>

            <Col md={1}>
              <Form.Select size="sm" onChange={e => setCurrency(e.target.value)} value={currency}>
                <option value={'main'}>{mainCurrency.code}</option>
                <option value={'secondary'}>{secondaryCurrency.code}</option>
              </Form.Select>
            </Col>




            {filter?.accountId &&


              <>


                <Col md={2}>
                  <SearchFilter setFilter={setFilter} />
                </Col>

                <Col md={3}>
                  <DatePicker setFilter={setFilter} filter={filter} />
                </Col>


                <Col md={1}>
                </Col>




                <Col md={2} className="d-flex justify-content-end">

                  <Button onClick={reportModal}>
                    <FiPrinter size={18} />
                  </Button>


                  <Button onClick={refreshTableFunction}>
                    <FiRotateCcw size={18} />
                  </Button>
                </Col>
              </>

            }

          </Row>




          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={newColumnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
            height={true}
            report={report}
            reportRef={reportRef}
            statementreportRef={statementreportRef}
            statementreport={statementReport}
          />

          {viewModal &&
            <ViewModal
              showModal={showViewModal}
              toggleModal={viewModal}
              journalVoucherId={idRow?.journalVoucherId}
            />
          }

          {showReportModal &&
            <AccountStatementReport
              showModal={showReportModal}
              toggleModal={reportModal}
              filter={filter}
              currency={currency}
              mainCurrency={mainCurrency}
              secondaryCurrency={secondaryCurrency}
              reportRef={reportRef}
            />
          }

        </div>
      }


    </div >
  )
}

export default AccountStatement;
